module.exports = __webpack_public_path__ + "img/default_type_6.76047ff1.png";